// @ts-ignore
import { init, captureException } from '@sentry/browser'
import env from '../env'

export const setupErrorTracking = () => {
    if (env.isProduction) {
        init({ dsn: env.sentryDns })
    }
}

export const raiseError = (e: Error | string) => {
    const error = typeof e === 'string' ? new Error(e) : e
    if (env.isProduction) {
        captureException(error)
    } else {
        throw error
    }
}

export const captureError = (e: Error | string) => {
    const error = typeof e === 'string' ? new Error(e) : e
    if (env.isProduction) {
        captureException(error)
    } else {
        console.error(error)
    }
}

export const withIgnoreError = (fn: (...args: any[]) => any) => (...args) => {
    try {
        return fn(...args)
    // eslint-disable-next-line no-empty
    } catch (e) {}
}

export const withCapture = (fn: (...args: any[]) => any) => (...args) => {
    try {
        return fn(...args)
    } catch (e) {
        captureError(e)
    }
}
